<template>
  <div class="container-steps">
    <div
      v-for="step in steps" :key="step.id"
      class="employee-task mb-2 d-flex flex-column step-box"
    >
      <div class="d-flex justify-content-between align-items-center">
        <b-media no-body>
          <b-media-aside class="mr-75">
            <b-avatar
              v-if="!step.paso.subrogadoId"
              rounded
              size="42"
              :src="step.paso.avatar"
            />
            <b-avatar
              rounded
              v-if="step.paso.subrogadoId"
              :text="step.paso.subrogado | avatarName"
              size="42"
              class="mt-25 mr-75"
            />
          </b-media-aside>
          <b-media-body class="my-auto">
            <h6 class="mb-0" v-if="!step.paso.subrogadoId" >
             {{step.numeroPaso}} - {{ step.paso.responsable }}
            </h6>
            <h6 class="mb-0" v-if="step.paso.subrogadoId" title="Suplente">
              {{step.numeroPaso}} - {{ step.paso.subrogado }}
               <span title="Suplente">
                (S)
              </span>
            </h6>
            <small>
              <b
                v-if="step.paso.aprobacionesTipoPasoId.toString() === stepTypes.proveedor.toString()"
              >
                {{getStepType(step)}} -
              </b>
              <span v-if="isNormal(step)">{{getRolType(step)}}</span>
              <span v-if="isOffice(step)">Oficina</span>
              <span v-if="isOfficer(step)">Oficial de parte</span>
            </small>
            <small
              v-if="step.paso.responsableCorreo"
              class="d-block text-muted"
            >
              {{ step.paso.responsableCorreo }}
            </small>
          </b-media-body>
        </b-media>
        <div class="d-flex align-items-center">
          <small class="text-muted mr-75" v-if="step.minutosEnPaso != null && step.minutosEnPaso >= 0">
            {{ step.minutosEnPaso | timeApprovals(step.minutosEnPaso, true) }}
          </small>
          <b-avatar
            v-if="editable && isPerson(step)"
            rounded
            size="24"
            variant="light-primary"
            class="mr-50 cursor-pointer"
            v-b-tooltip="'Cambiar correo'"
            @click.native="openChangeEmail(step)"
          >
            <feather-icon size="14" icon="MailIcon" />
          </b-avatar>
          <span>
            <b-media-aside class="mr-1 d-flex align-items-center">
               <b-avatar
                 v-if="step.paso.distributed == 1"
                 rounded
                 class="mr-1"
                 v-b-tooltip="'Distribuido: se asigna a 1 persona del grupo secuencialmente'"
                 size="28"
                 variant="light-warning"
               >
                <feather-icon
                  size="18"
                  icon="Share2Icon"
                />
              </b-avatar>
               <b-avatar
                 v-if="step.retenido === 'Y'"
                 rounded
                 class="mr-2"
                 v-b-tooltip="'Retenido'"
                 size="28"
                 variant="light-primary"
               >
                <feather-icon
                  size="18"
                  icon="LockIcon"
                />
              </b-avatar>
              <b-avatar
                v-if="step.aprobacionesPasoEstadoId === flowStates.PROCESSING"
                rounded
                v-b-tooltip="'Procesando'"
                size="28"
                variant="light-warning"
              >
                <feather-icon
                  size="18"
                  icon="LoaderIcon"
                />
              </b-avatar>
              <b-avatar
                v-if="step.aprobacionesPasoEstadoId === flowStates.PENDING"
                rounded
                v-b-tooltip="'Pendiente'"
                size="28"
                variant="light-secondary"
              >
                <feather-icon
                  size="18"
                  icon="AlertCircleIcon"
                />
              </b-avatar>
              <b-avatar
                v-if="step.aprobacionesPasoEstadoId === flowStates.APPROVED"
                rounded
                v-b-tooltip="'Aprobado'"
                size="28"
                variant="light-success"
              >
                <feather-icon
                  size="18"
                  icon="ThumbsUpIcon"
                />
              </b-avatar>
              <b-avatar
                v-if="step.aprobacionesPasoEstadoId === flowStates.REJECTED"
                rounded
                v-b-tooltip="'Rechazado'"
                size="28"
                variant="light-danger"
              >
                <feather-icon
                  size="18"
                  icon="ThumbsDownIcon"
                />
              </b-avatar>
              <b-avatar
                v-if="step.aprobacionesPasoEstadoId === flowStates.FORWARDED"
                rounded
                v-b-tooltip="'Reenviado'"
                size="28"
                variant="light-info"
              >
                <feather-icon
                  size="18"
                  icon="ShuffleIcon"
                />
              </b-avatar>
              <b-avatar
                class="ml-1"
                v-if="(step.aprobacionesPasoEstadoId === flowStates.PROCESSING
                 || step.aprobacionesPasoEstadoId === flowStates.APPROVED
                 || step.aprobacionesPasoEstadoId === flowStates.REJECTED)
                 && step.esTemporal && !step.temporalContinuaFlujo"
                rounded
                v-b-tooltip="'Se devuelve al paso anterior'"
                size="20"
                variant="light-warning"
              >
                <feather-icon
                  size="18"
                  icon="ArrowLeftIcon"
                />
              </b-avatar>
               <b-avatar
                 class="ml-1"
                 v-if="(step.aprobacionesPasoEstadoId === flowStates.PROCESSING
                 || step.aprobacionesPasoEstadoId === flowStates.APPROVED
                 || step.aprobacionesPasoEstadoId === flowStates.REJECTED)
                  && step.esTemporal && step.temporalContinuaFlujo"
                 rounded
                 v-b-tooltip="'Sigue al paso siguiente'"
                 size="20"
                 variant="light-success"
               >
                <feather-icon
                  size="18"
                  icon="ArrowRightIcon"
                />
              </b-avatar>
              <b-avatar
                v-if="step.aprobacionesPasoEstadoId === flowStates.RETURNED"
                rounded
                v-b-tooltip="'Devuelto'"
                size="28"
                variant="light-info"
              >
                <feather-icon
                  size="18"
                  icon="CornerUpLeftIcon"
                />
              </b-avatar>
              <b-avatar
                v-if="step.aprobacionesPasoEstadoId === flowStates.SIGNED"
                rounded
                v-b-tooltip="'Firmando'"
                size="28"
                variant="light-warning"
              >
                <feather-icon
                  size="18"
                  icon="PenToolIcon"
                />
              </b-avatar>
            </b-media-aside>
          </span>
        </div>
      </div>
      <div
        v-if="editingStepId === step.id"
        class="change-email-form mt-1 ml-4 pl-2"
      >
        <small class="text-muted font-weight-bold d-block mb-50">Cambiar correo</small>
        <div class="d-flex align-items-center">
          <b-form-input
            v-model="newEmail"
            type="email"
            size="sm"
            placeholder="Nuevo correo"
            class="mr-50"
            :state="emailValid"
          />
          <b-button
            variant="primary"
            size="sm"
            :disabled="!emailValid || savingEmail"
            @click="confirmChangeEmail(step)"
            class="mr-50"
          >
            <b-spinner v-if="savingEmail" small />
            <span v-else>Guardar</span>
          </b-button>
          <b-button
            variant="outline-secondary"
            size="sm"
            @click="cancelChangeEmail"
          >
            Cancelar
          </b-button>
        </div>
      </div>
      <div
        v-if="showParticipants && isGroup(step) && getVisibleParticipants(step).length"
        class="participants-list mt-1 ml-4 pl-2"
      >
        <small class="text-muted font-weight-bold">Participantes del grupo</small>
        <div
          v-for="(participant, idx) in getVisibleParticipants(step)"
          :key="idx"
          class="d-flex align-items-center mt-50"
        >
          <b-avatar
            rounded
            size="10"
            :variant="getParticipantVariant(participant)"
            class="mr-50"
          />
          <small>{{ participant.nombre }}</small>
          <small
            v-if="participant.aprobacionesPasoEstadoId"
            class="ml-50 text-muted"
          >
            ({{ getParticipantStatus(participant) }})
          </small>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Ripple from 'vue-ripple-directive';
import {
  BMedia, BMediaAside, BAvatar, BMediaBody, BFormInput, BButton
} from 'bootstrap-vue';

import {
  rolTypes,
  stepTypesCode,
  stepTypes
} from '@/febos/chile/approvals/components/trays/managementTray/constants';
import ApprovalProcessStates from '@/febos/chile/approvals/mixins/ApprovalProcessStates';
import { changeStepEmail } from '@/febos/servicios/api/aprobaciones.api';

export default {
  components: {
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
    BFormInput,
    BButton
  },
  directives: { Ripple },
  data() {
    return {
      stepTypes: stepTypesCode,
      commentary: '',
      flowStates: ApprovalProcessStates,
      editingStepId: null,
      newEmail: '',
      savingEmail: false
    };
  },
  computed: {
    emailValid() {
      if (!this.newEmail) return null;
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(this.newEmail);
    }
  },
  props: {
    ejecucion: {
      type: Object,
      default: () => ({})
    },
    steps: {
      type: Array,
      required: true
    },
    showParticipants: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: false
    },
    ejecucionId: {
      type: String,
      default: ''
    }
  },
  methods: {
    getStepType(step) {
      return stepTypes[step.paso.aprobacionesTipoPasoId];
    },
    getRolType(step) {
      return rolTypes[step.paso.aprobacionesTipoRolId];
    },
    isGroup(step) {
      return step.paso.aprobacionesTipoPasoId.toString() === stepTypesCode.grupo.toString();
    },
    isPerson(step) {
      return step.paso.aprobacionesTipoPasoId.toString() === stepTypesCode.persona.toString();
    },
    getGroupParticipants(step) {
      return step.paso.participantes || step.paso.grupoUsuarios || [];
    },
    getVisibleParticipants(step) {
      const participants = this.getGroupParticipants(step);
      if (this.isCurrentStep(step)) {
        return participants;
      }
      return participants.filter((p) => {
        const state = (p.aprobacionesPasoEstadoId || '').toString();
        return state === this.flowStates.APPROVED || state === this.flowStates.REJECTED;
      });
    },
    isCurrentStep(step) {
      const stepState = (step.aprobacionesPasoEstadoId || '').toString();
      return stepState === this.flowStates.PROCESSING;
    },
    isOffice(step) {
      return step.paso.aprobacionesTipoPasoId.toString() === stepTypesCode.oficina.toString();
    },
    isOfficer(step) {
      return step.paso.aprobacionesTipoPasoId.toString() === stepTypesCode.oficial.toString();
    },
    isNormal(step) {
      return step.paso.aprobacionesTipoPasoId.toString() !== stepTypesCode.oficial.toString()
        && step.paso.aprobacionesTipoPasoId.toString() !== stepTypesCode.oficina.toString();
    },
    getParticipantVariant(participant) {
      const state = (participant.aprobacionesPasoEstadoId || '').toString();
      if (state === this.flowStates.APPROVED) return 'success';
      if (state === this.flowStates.REJECTED) return 'danger';
      return 'secondary';
    },
    getParticipantStatus(participant) {
      const state = (participant.aprobacionesPasoEstadoId || '').toString();
      if (state === this.flowStates.APPROVED) return 'Aprobado';
      if (state === this.flowStates.REJECTED) return 'Rechazado';
      return 'Sin acción';
    },
    openChangeEmail(step) {
      this.editingStepId = step.id;
      this.newEmail = step.paso.responsableCorreo || '';
    },
    cancelChangeEmail() {
      this.editingStepId = null;
      this.newEmail = '';
    },
    async confirmChangeEmail(step) {
      if (!this.emailValid) return;
      this.savingEmail = true;
      try {
        const body = {
          responsableCorreo: this.newEmail,
          responsable: step.paso.responsable,
          tipoValorResponsableId: step.paso.tipoValorResponsableId,
          aprobacionesTipoPasoId: parseInt(step.paso.aprobacionesTipoPasoId, 10),
          aprobacionesTipoRolId: parseInt(step.paso.aprobacionesTipoRolId, 10),
          numeroPaso: step.numeroPaso
        };
        await changeStepEmail(this.ejecucionId, step.aprobacionesPasoId, body);
        step.paso.responsableCorreo = this.newEmail;
        this.$emit('email-changed', { step, email: this.newEmail });
        this.editingStepId = null;
        this.newEmail = '';
      } catch (error) {
        this.$emit('error', error);
      } finally {
        this.savingEmail = false;
      }
    }
  }
};
</script>
<style>
.step {
  height: 80px;
  width: 200px;
  border: 1px solid #7d66f8;
  padding: 2px;
}
.container-steps {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #7d66f81f;
  border-radius: 5px;
  background: #7d66f812;
}

.step-box {
  border-bottom: 1px solid #7d66f8;
  padding: 4px;
}

.current-step {
  color: #00cc69;
  font-size: 10px;
}
.passed-step {
  color: #ce854b;
  font-size: 10px;
}

.participants-list {
  border-left: 2px solid #7d66f84d;
}

.change-email-form {
  border-left: 2px solid #7d66f8;
  padding-bottom: 4px;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
